export default __webpack_public_path__ + "static/media/SocialDetox-hover.d1540f99.svg";